<div class="notificacoes" *ngIf="notificacaoMensagens.length >0" #notificacao>
  <div class="alert" [ngClass]="notificacaoStatus">
    <a href="javascript:void(0)" (click)="fecharNotificacao()" class="close" data-dismiss="alert"
       aria-label="fechar">X</a>
    <ul *ngFor="let item of notificacaoMensagens">
      <li>{{item}}</li>
    </ul>
  </div>

</div>
